import { render, staticRenderFns } from "./ReviewSettingsBusinessCardDetails.vue?vue&type=template&id=e30466ee&"
import script from "./ReviewSettingsBusinessCardDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewSettingsBusinessCardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports